// Currency Data and Conversion
// Exchange rates relative to GBP (base currency)
// Rates are approximate and should be updated for production use

export const currencies = [
  // Major Western Currencies
  { code: "GBP", symbol: "£", name: "British Pound", flag: "🇬🇧", rate: 1 },
  { code: "USD", symbol: "$", name: "US Dollar", flag: "🇺🇸", rate: 1.27 },
  { code: "EUR", symbol: "€", name: "Euro", flag: "🇪🇺", rate: 1.17 },
  { code: "CAD", symbol: "C$", name: "Canadian Dollar", flag: "🇨🇦", rate: 1.73 },
  { code: "AUD", symbol: "A$", name: "Australian Dollar", flag: "🇦🇺", rate: 1.95 },
  { code: "NZD", symbol: "NZ$", name: "New Zealand Dollar", flag: "🇳🇿", rate: 2.12 },
  { code: "CHF", symbol: "CHF", name: "Swiss Franc", flag: "🇨🇭", rate: 1.12 },
  
  // Middle East
  { code: "SAR", symbol: "﷼", name: "Saudi Riyal", flag: "🇸🇦", rate: 4.76 },
  { code: "AED", symbol: "د.إ", name: "UAE Dirham", flag: "🇦🇪", rate: 4.66 },
  { code: "QAR", symbol: "﷼", name: "Qatari Riyal", flag: "🇶🇦", rate: 4.62 },
  { code: "KWD", symbol: "د.ك", name: "Kuwaiti Dinar", flag: "🇰🇼", rate: 0.39 },
  { code: "BHD", symbol: "BD", name: "Bahraini Dinar", flag: "🇧🇭", rate: 0.48 },
  { code: "OMR", symbol: "ر.ع.", name: "Omani Rial", flag: "🇴🇲", rate: 0.49 },
  { code: "JOD", symbol: "JD", name: "Jordanian Dinar", flag: "🇯🇴", rate: 0.90 },
  { code: "ILS", symbol: "₪", name: "Israeli Shekel", flag: "🇮🇱", rate: 4.72 },
  { code: "LBP", symbol: "ل.ل", name: "Lebanese Pound", flag: "🇱🇧", rate: 113580 },
  { code: "IQD", symbol: "ع.د", name: "Iraqi Dinar", flag: "🇮🇶", rate: 1663.45 },
  { code: "IRR", symbol: "﷼", name: "Iranian Rial", flag: "🇮🇷", rate: 53450 },
  { code: "YER", symbol: "﷼", name: "Yemeni Rial", flag: "🇾🇪", rate: 317.25 },
  
  // South Asia
  { code: "PKR", symbol: "₨", name: "Pakistani Rupee", flag: "🇵🇰", rate: 353.21 },
  { code: "INR", symbol: "₹", name: "Indian Rupee", flag: "🇮🇳", rate: 105.89 },
  { code: "BDT", symbol: "৳", name: "Bangladeshi Taka", flag: "🇧🇩", rate: 139.45 },
  { code: "LKR", symbol: "Rs", name: "Sri Lankan Rupee", flag: "🇱🇰", rate: 385.67 },
  { code: "NPR", symbol: "रू", name: "Nepalese Rupee", flag: "🇳🇵", rate: 169.45 },
  { code: "AFN", symbol: "؋", name: "Afghan Afghani", flag: "🇦🇫", rate: 89.12 },
  
  // Southeast Asia
  { code: "MYR", symbol: "RM", name: "Malaysian Ringgit", flag: "🇲🇾", rate: 5.97 },
  { code: "IDR", symbol: "Rp", name: "Indonesian Rupiah", flag: "🇮🇩", rate: 20145.67 },
  { code: "SGD", symbol: "S$", name: "Singapore Dollar", flag: "🇸🇬", rate: 1.71 },
  { code: "THB", symbol: "฿", name: "Thai Baht", flag: "🇹🇭", rate: 45.23 },
  { code: "PHP", symbol: "₱", name: "Philippine Peso", flag: "🇵🇭", rate: 71.45 },
  { code: "VND", symbol: "₫", name: "Vietnamese Dong", flag: "🇻🇳", rate: 31245.78 },
  { code: "MMK", symbol: "K", name: "Myanmar Kyat", flag: "🇲🇲", rate: 2665.45 },
  { code: "KHR", symbol: "៛", name: "Cambodian Riel", flag: "🇰🇭", rate: 5145.67 },
  { code: "BND", symbol: "B$", name: "Brunei Dollar", flag: "🇧🇳", rate: 1.71 },
  
  // East Asia
  { code: "CNY", symbol: "¥", name: "Chinese Yuan", flag: "🇨🇳", rate: 9.23 },
  { code: "JPY", symbol: "¥", name: "Japanese Yen", flag: "🇯🇵", rate: 192.45 },
  { code: "KRW", symbol: "₩", name: "South Korean Won", flag: "🇰🇷", rate: 1678.34 },
  { code: "HKD", symbol: "HK$", name: "Hong Kong Dollar", flag: "🇭🇰", rate: 9.92 },
  { code: "TWD", symbol: "NT$", name: "Taiwan Dollar", flag: "🇹🇼", rate: 40.12 },
  { code: "MOP", symbol: "MOP$", name: "Macanese Pataca", flag: "🇲🇴", rate: 10.21 },
  
  // Europe (Non-Euro)
  { code: "TRY", symbol: "₺", name: "Turkish Lira", flag: "🇹🇷", rate: 41.23 },
  { code: "RUB", symbol: "₽", name: "Russian Ruble", flag: "🇷🇺", rate: 113.45 },
  { code: "PLN", symbol: "zł", name: "Polish Zloty", flag: "🇵🇱", rate: 5.12 },
  { code: "CZK", symbol: "Kč", name: "Czech Koruna", flag: "🇨🇿", rate: 29.45 },
  { code: "HUF", symbol: "Ft", name: "Hungarian Forint", flag: "🇭🇺", rate: 456.78 },
  { code: "RON", symbol: "lei", name: "Romanian Leu", flag: "🇷🇴", rate: 5.78 },
  { code: "BGN", symbol: "лв", name: "Bulgarian Lev", flag: "🇧🇬", rate: 2.29 },
  { code: "HRK", symbol: "kn", name: "Croatian Kuna", flag: "🇭🇷", rate: 8.82 },
  { code: "SEK", symbol: "kr", name: "Swedish Krona", flag: "🇸🇪", rate: 13.45 },
  { code: "NOK", symbol: "kr", name: "Norwegian Krone", flag: "🇳🇴", rate: 13.78 },
  { code: "DKK", symbol: "kr", name: "Danish Krone", flag: "🇩🇰", rate: 8.72 },
  { code: "ISK", symbol: "kr", name: "Icelandic Krona", flag: "🇮🇸", rate: 175.34 },
  { code: "UAH", symbol: "₴", name: "Ukrainian Hryvnia", flag: "🇺🇦", rate: 52.34 },
  { code: "RSD", symbol: "дин.", name: "Serbian Dinar", flag: "🇷🇸", rate: 137.23 },
  { code: "BAM", symbol: "KM", name: "Bosnia Mark", flag: "🇧🇦", rate: 2.29 },
  { code: "MKD", symbol: "ден", name: "Macedonian Denar", flag: "🇲🇰", rate: 72.12 },
  { code: "ALL", symbol: "L", name: "Albanian Lek", flag: "🇦🇱", rate: 118.45 },
  { code: "GEL", symbol: "₾", name: "Georgian Lari", flag: "🇬🇪", rate: 3.45 },
  { code: "AMD", symbol: "֏", name: "Armenian Dram", flag: "🇦🇲", rate: 492.34 },
  { code: "AZN", symbol: "₼", name: "Azerbaijani Manat", flag: "🇦🇿", rate: 2.16 },
  
  // Africa
  { code: "EGP", symbol: "E£", name: "Egyptian Pound", flag: "🇪🇬", rate: 62.18 },
  { code: "NGN", symbol: "₦", name: "Nigerian Naira", flag: "🇳🇬", rate: 1978.45 },
  { code: "ZAR", symbol: "R", name: "South African Rand", flag: "🇿🇦", rate: 23.12 },
  { code: "KES", symbol: "KSh", name: "Kenyan Shilling", flag: "🇰🇪", rate: 163.78 },
  { code: "MAD", symbol: "د.م.", name: "Moroccan Dirham", flag: "🇲🇦", rate: 12.67 },
  { code: "TND", symbol: "د.ت", name: "Tunisian Dinar", flag: "🇹🇳", rate: 3.95 },
  { code: "DZD", symbol: "د.ج", name: "Algerian Dinar", flag: "🇩🇿", rate: 170.45 },
  { code: "LYD", symbol: "ل.د", name: "Libyan Dinar", flag: "🇱🇾", rate: 6.12 },
  { code: "SDG", symbol: "ج.س.", name: "Sudanese Pound", flag: "🇸🇩", rate: 762.34 },
  { code: "ETB", symbol: "Br", name: "Ethiopian Birr", flag: "🇪🇹", rate: 143.56 },
  { code: "GHS", symbol: "₵", name: "Ghanaian Cedi", flag: "🇬🇭", rate: 15.89 },
  { code: "TZS", symbol: "TSh", name: "Tanzanian Shilling", flag: "🇹🇿", rate: 3178.45 },
  { code: "UGX", symbol: "USh", name: "Ugandan Shilling", flag: "🇺🇬", rate: 4712.34 },
  { code: "RWF", symbol: "FRw", name: "Rwandan Franc", flag: "🇷🇼", rate: 1567.89 },
  { code: "XOF", symbol: "CFA", name: "West African CFA", flag: "🌍", rate: 767.45 },
  { code: "XAF", symbol: "FCFA", name: "Central African CFA", flag: "🌍", rate: 767.45 },
  { code: "MUR", symbol: "₨", name: "Mauritian Rupee", flag: "🇲🇺", rate: 57.89 },
  { code: "BWP", symbol: "P", name: "Botswana Pula", flag: "🇧🇼", rate: 17.34 },
  { code: "ZMW", symbol: "ZK", name: "Zambian Kwacha", flag: "🇿🇲", rate: 34.56 },
  
  // Americas
  { code: "MXN", symbol: "MX$", name: "Mexican Peso", flag: "🇲🇽", rate: 21.78 },
  { code: "BRL", symbol: "R$", name: "Brazilian Real", flag: "🇧🇷", rate: 6.23 },
  { code: "ARS", symbol: "ARS$", name: "Argentine Peso", flag: "🇦🇷", rate: 1123.45 },
  { code: "CLP", symbol: "CLP$", name: "Chilean Peso", flag: "🇨🇱", rate: 1178.34 },
  { code: "COP", symbol: "COP$", name: "Colombian Peso", flag: "🇨🇴", rate: 5012.45 },
  { code: "PEN", symbol: "S/", name: "Peruvian Sol", flag: "🇵🇪", rate: 4.78 },
  { code: "VES", symbol: "Bs", name: "Venezuelan Bolivar", flag: "🇻🇪", rate: 45.67 },
  { code: "UYU", symbol: "$U", name: "Uruguayan Peso", flag: "🇺🇾", rate: 50.34 },
  { code: "PYG", symbol: "₲", name: "Paraguayan Guarani", flag: "🇵🇾", rate: 9345.67 },
  { code: "BOB", symbol: "Bs.", name: "Bolivian Boliviano", flag: "🇧🇴", rate: 8.78 },
  { code: "DOP", symbol: "RD$", name: "Dominican Peso", flag: "🇩🇴", rate: 74.56 },
  { code: "GTQ", symbol: "Q", name: "Guatemalan Quetzal", flag: "🇬🇹", rate: 9.89 },
  { code: "CRC", symbol: "₡", name: "Costa Rican Colon", flag: "🇨🇷", rate: 645.78 },
  { code: "PAB", symbol: "B/.", name: "Panamanian Balboa", flag: "🇵🇦", rate: 1.27 },
  { code: "JMD", symbol: "J$", name: "Jamaican Dollar", flag: "🇯🇲", rate: 198.45 },
  { code: "TTD", symbol: "TT$", name: "Trinidad Dollar", flag: "🇹🇹", rate: 8.62 },
  { code: "BBD", symbol: "Bds$", name: "Barbadian Dollar", flag: "🇧🇧", rate: 2.54 },
  { code: "BSD", symbol: "B$", name: "Bahamian Dollar", flag: "🇧🇸", rate: 1.27 },
  { code: "HTG", symbol: "G", name: "Haitian Gourde", flag: "🇭🇹", rate: 167.89 },
  
  // Oceania
  { code: "FJD", symbol: "FJ$", name: "Fijian Dollar", flag: "🇫🇯", rate: 2.89 },
  { code: "PGK", symbol: "K", name: "Papua New Guinea Kina", flag: "🇵🇬", rate: 4.98 },
  { code: "WST", symbol: "WS$", name: "Samoan Tala", flag: "🇼🇸", rate: 3.56 },
  { code: "TOP", symbol: "T$", name: "Tongan Paʻanga", flag: "🇹🇴", rate: 3.01 },
  { code: "VUV", symbol: "VT", name: "Vanuatu Vatu", flag: "🇻🇺", rate: 151.23 },
  { code: "SBD", symbol: "SI$", name: "Solomon Islands Dollar", flag: "🇸🇧", rate: 10.78 },
];

// Country code to currency code mapping
export const countryToCurrency = {
  // Europe
  GB: "GBP", // United Kingdom
  IE: "EUR", // Ireland
  FR: "EUR", // France
  DE: "EUR", // Germany
  IT: "EUR", // Italy
  ES: "EUR", // Spain
  PT: "EUR", // Portugal
  NL: "EUR", // Netherlands
  BE: "EUR", // Belgium
  AT: "EUR", // Austria
  GR: "EUR", // Greece
  FI: "EUR", // Finland
  LU: "EUR", // Luxembourg
  MT: "EUR", // Malta
  CY: "EUR", // Cyprus
  SK: "EUR", // Slovakia
  SI: "EUR", // Slovenia
  EE: "EUR", // Estonia
  LV: "EUR", // Latvia
  LT: "EUR", // Lithuania
  CH: "CHF", // Switzerland
  NO: "NOK", // Norway
  SE: "SEK", // Sweden
  DK: "DKK", // Denmark
  IS: "ISK", // Iceland
  PL: "PLN", // Poland
  CZ: "CZK", // Czech Republic
  HU: "HUF", // Hungary
  RO: "RON", // Romania
  BG: "BGN", // Bulgaria
  HR: "HRK", // Croatia
  RS: "RSD", // Serbia
  BA: "BAM", // Bosnia
  MK: "MKD", // North Macedonia
  AL: "ALL", // Albania
  UA: "UAH", // Ukraine
  RU: "RUB", // Russia
  GE: "GEL", // Georgia
  AM: "AMD", // Armenia
  AZ: "AZN", // Azerbaijan
  TR: "TRY", // Turkey
  
  // Middle East
  SA: "SAR", // Saudi Arabia
  AE: "AED", // UAE
  QA: "QAR", // Qatar
  KW: "KWD", // Kuwait
  BH: "BHD", // Bahrain
  OM: "OMR", // Oman
  JO: "JOD", // Jordan
  LB: "LBP", // Lebanon
  IQ: "IQD", // Iraq
  IR: "IRR", // Iran
  YE: "YER", // Yemen
  IL: "ILS", // Israel
  PS: "ILS", // Palestine
  SY: "SYP", // Syria
  
  // South Asia
  PK: "PKR", // Pakistan
  IN: "INR", // India
  BD: "BDT", // Bangladesh
  LK: "LKR", // Sri Lanka
  NP: "NPR", // Nepal
  AF: "AFN", // Afghanistan
  MV: "MVR", // Maldives
  BT: "BTN", // Bhutan
  
  // Southeast Asia
  MY: "MYR", // Malaysia
  ID: "IDR", // Indonesia
  SG: "SGD", // Singapore
  TH: "THB", // Thailand
  PH: "PHP", // Philippines
  VN: "VND", // Vietnam
  MM: "MMK", // Myanmar
  KH: "KHR", // Cambodia
  LA: "LAK", // Laos
  BN: "BND", // Brunei
  TL: "USD", // Timor-Leste (uses USD)
  
  // East Asia
  CN: "CNY", // China
  JP: "JPY", // Japan
  KR: "KRW", // South Korea
  HK: "HKD", // Hong Kong
  TW: "TWD", // Taiwan
  MO: "MOP", // Macau
  MN: "MNT", // Mongolia
  
  // Africa
  EG: "EGP", // Egypt
  NG: "NGN", // Nigeria
  ZA: "ZAR", // South Africa
  KE: "KES", // Kenya
  MA: "MAD", // Morocco
  TN: "TND", // Tunisia
  DZ: "DZD", // Algeria
  LY: "LYD", // Libya
  SD: "SDG", // Sudan
  ET: "ETB", // Ethiopia
  GH: "GHS", // Ghana
  TZ: "TZS", // Tanzania
  UG: "UGX", // Uganda
  RW: "RWF", // Rwanda
  MU: "MUR", // Mauritius
  BW: "BWP", // Botswana
  ZM: "ZMW", // Zambia
  ZW: "USD", // Zimbabwe (uses USD)
  SN: "XOF", // Senegal
  CI: "XOF", // Ivory Coast
  CM: "XAF", // Cameroon
  GA: "XAF", // Gabon
  CG: "XAF", // Congo
  CD: "CDF", // DR Congo
  AO: "AOA", // Angola
  MZ: "MZN", // Mozambique
  NA: "NAD", // Namibia
  
  // Americas
  US: "USD", // United States
  CA: "CAD", // Canada
  MX: "MXN", // Mexico
  BR: "BRL", // Brazil
  AR: "ARS", // Argentina
  CL: "CLP", // Chile
  CO: "COP", // Colombia
  PE: "PEN", // Peru
  VE: "VES", // Venezuela
  EC: "USD", // Ecuador (uses USD)
  UY: "UYU", // Uruguay
  PY: "PYG", // Paraguay
  BO: "BOB", // Bolivia
  DO: "DOP", // Dominican Republic
  GT: "GTQ", // Guatemala
  HN: "HNL", // Honduras
  SV: "USD", // El Salvador (uses USD)
  NI: "NIO", // Nicaragua
  CR: "CRC", // Costa Rica
  PA: "PAB", // Panama
  CU: "CUP", // Cuba
  JM: "JMD", // Jamaica
  TT: "TTD", // Trinidad & Tobago
  BB: "BBD", // Barbados
  BS: "BSD", // Bahamas
  HT: "HTG", // Haiti
  PR: "USD", // Puerto Rico
  
  // Oceania
  AU: "AUD", // Australia
  NZ: "NZD", // New Zealand
  FJ: "FJD", // Fiji
  PG: "PGK", // Papua New Guinea
  WS: "WST", // Samoa
  TO: "TOP", // Tonga
  VU: "VUV", // Vanuatu
  SB: "SBD", // Solomon Islands
  NC: "XPF", // New Caledonia
  PF: "XPF", // French Polynesia
  GU: "USD", // Guam
};

// Get currency code from country code
export const getCurrencyByCountry = (countryCode) => {
  const currencyCode = countryToCurrency[countryCode];
  if (!currencyCode) return null;
  return currencies.find(c => c.code === currencyCode) || null;
};

// Convert from GBP to target currency
export const convertFromGBP = (amountGBP, targetCurrencyCode) => {
  const currency = currencies.find(c => c.code === targetCurrencyCode);
  if (!currency) return amountGBP;
  return Math.round(amountGBP * currency.rate * 100) / 100;
};

// Convert to GBP from source currency
export const convertToGBP = (amount, sourceCurrencyCode) => {
  const currency = currencies.find(c => c.code === sourceCurrencyCode);
  if (!currency) return amount;
  return Math.round((amount / currency.rate) * 100) / 100;
};

// Format price with currency symbol
export const formatPrice = (amount, currencyCode) => {
  const currency = currencies.find(c => c.code === currencyCode) || currencies[0];
  
  // Format number with appropriate decimal places
  let formattedNumber;
  if (amount >= 1000) {
    formattedNumber = amount.toLocaleString('en-US', { 
      minimumFractionDigits: 0, 
      maximumFractionDigits: 0 
    });
  } else {
    formattedNumber = amount.toLocaleString('en-US', { 
      minimumFractionDigits: 2, 
      maximumFractionDigits: 2 
    });
  }
  
  return `${currency.symbol}${formattedNumber}`;
};

// Get currency by code
export const getCurrency = (code) => {
  return currencies.find(c => c.code === code) || currencies[0];
};
